import {
  AppType,
  CommonMessageType,
} from 'electron-communication-lib/CommonForApp';
import {useState} from 'react';

import {isElectron} from '@ELib/utilities/HelperFunctions';
import {useMountEffect} from '@ELib/utilities/hooks/effectHelpers';
import {useCommonMessageExchange} from '@ELib/utilities/hooks/useElectronMessageExchange';

export const useAppType = (): AppType | null => {
  const [appType, setAppType] = useState<AppType | null>(null);

  useMountEffect(() => {
    if (!isElectron()) {
      setAppType(AppType.WEB_BROWSER);
    }
  });

  useCommonMessageExchange({
    message: {
      type: CommonMessageType.GET_APP_TYPE,
      payload: null,
    },
    responsePayloadHandler: setAppType,
  });

  return appType;
};
